import { styled, type StyledDecorator } from '@glitz/react';
import * as React from 'react';

type PropType = {
  countdown: string;
  timeslotDecorator?: StyledDecorator;
};

export default styled(function Countdown({ countdown, timeslotDecorator }: PropType) {
  const date = new Date();
  const now_utc = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
  );

  const countdownDate = new Date(countdown);
  const countdown_utc = Date.UTC(
    countdownDate.getFullYear(),
    countdownDate.getMonth(),
    countdownDate.getDate(),
    countdownDate.getHours(),
    countdownDate.getMinutes(),
    countdownDate.getSeconds(),
  );

  const timeleft = countdown_utc - now_utc;

  const interval = React.useRef<number>(undefined);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);

  React.useEffect(() => {
    interval.current = window.setInterval(() => {
      forceUpdate();
    }, 1000);

    return () => {
      clearInterval(interval.current);
    };
  }, []);

  if (timeleft < 0) {
    clearInterval(interval.current);
    return null;
  }
  // Calculating the days, hours, minutes and seconds left
  const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

  return (
    <Time>
      {days > 0 && (
        <>
          <TimeSlot css={timeslotDecorator}>{days}</TimeSlot>:
        </>
      )}
      <TimeSlot css={timeslotDecorator}>
        {hours.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
      </TimeSlot>
      :
      <TimeSlot css={timeslotDecorator}>
        {minutes.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
      </TimeSlot>
      :
      <TimeSlot css={timeslotDecorator}>
        {seconds.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
      </TimeSlot>
    </Time>
  );
});

const TimeSlot = styled.span({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  textAlign: 'center',
  width: '1.75em',
  display: 'inline-block',
});

const Time = styled.span({
  display: 'display-inline',
  justifyContent: 'center',
});
